import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

const SeedingEvaluationReviewTagSchema = z
  .enum([
    'GOOD_CONTENT_QUALITY',
    'FOLLOWED_GUIDELINES',
    'GOOD_PRODUCT_DESCRIPTION',
    'FITS_BRAND_IMAGE',
    'GOOD_CAMPAIGN_PERFORMANCE',
    'FAST_FEEDBACK',
  ])
  .describe('SeedingEvaluationReviewTagSchema');

export type SeedingEvaluationReviewTag = z.infer<typeof SeedingEvaluationReviewTagSchema>;

const PostSeedingEvaluationRequestSchema = z
  .object({
    seedingParticipationId: z.number().int().min(1),
    brandId: z.string().min(1),
    rating: z.number().min(0.5).max(5),
    reviewTags: z.array(SeedingEvaluationReviewTagSchema).min(1),
    reviewText: z.string().max(500).nullable().optional(),
  })
  .describe('PostSeedingEvaluationRequestSchema');

export type PostSeedingEvaluationRequest = z.infer<typeof PostSeedingEvaluationRequestSchema>;

// 평가 등록 성공 시 BE 는 201 + 빈 본문을 반환한다(MusinsaStandardResponse 래퍼 없음).
// createApiResponseSchema(객체 기대)로 검증하면 빈 본문이 "expected object, received string"
// 으로 실패 → 성공이 에러로 처리되어 결과 목록 갱신(onSuccess invalidate)이 동작하지 않았다.
// 그 결과 평가 작성 버튼이 그대로 남아 재클릭 시 중복 등록(COMMON-001-002)이 발생했다. (QAT-39571)
// 빈 본문 mutation 선례(postCuratorWishlist 등)와 동일하게 z.unknown() 으로 검증한다.
// FAIL meta(중복 등록 등) 에러 처리는 executeStandardRequest 가 담당한다.
const PostSeedingEvaluationResponseSchema = z.unknown();

export type PostSeedingEvaluationResponse = z.infer<typeof PostSeedingEvaluationResponseSchema>;

/** POST `/v1/partner/seeding/evaluations` — 시딩 캠페인 큐레이터 평가 등록 */
export const postSeedingEvaluation = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PostSeedingEvaluationRequestSchema),
    async (body: PostSeedingEvaluationRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.post<PostSeedingEvaluationResponse>(
          partnerApiPath.postSeedingEvaluation,
          body,
        ),
      ),
    validateApiResponse(PostSeedingEvaluationResponseSchema),
  ),
);
